import { Schema } from "effect";

export const Keybinding = Schema.Struct({
  commandId: Schema.String,
  defaultKeys: Schema.Array(Schema.String),
  userKeys: Schema.optional(Schema.Array(Schema.String)),
  description: Schema.String
});
export type Keybinding = typeof Keybinding.Type;

export const coreBindings = (): readonly Keybinding[] => [
  { commandId: "global.command-palette", defaultKeys: ["⌘", "K"], description: "Open Global Command Palette" },
  { commandId: "review.toggle-palette", defaultKeys: ["⌘", "K"], description: "Open Review Commands" },
  { commandId: "review.submit", defaultKeys: ["⌘", "Enter"], description: "Submit Review" },
  { commandId: "review.next-file", defaultKeys: ["J"], description: "Next Modified File" },
  { commandId: "review.prev-file", defaultKeys: ["K"], description: "Previous Modified File" }
];
